export default __webpack_public_path__ + "static/media/img-industry-events.11cb90d4.svg";